import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
// Контактные данные
const PHONE_NUMBER = '380508399309';
const TELEGRAM_LINK = `https://t.me/+${PHONE_NUMBER}`;
const WHATSAPP_LINK = `https://wa.me/${PHONE_NUMBER}`;
const EMAIL = 'maximtovkach98@gmail.com';
export function Footer() {
  const {
    t,
    getPath
  } = useLanguage();
  return <footer className="w-full py-12 sm:py-16 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-165">
          {/* Services */}
          <div data-id="element-166">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-167">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-168">
              <li data-id="element-169">
                <a href={getPath('#services')} className="hover:underline" data-id="element-170">
                  {t('nav.services')}
                </a>
              </li>
              <li data-id="element-171">
                <a href={getPath('#consultation')} className="hover:underline" data-id="element-172">
                  {t('nav.getStarted')}
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-173">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-174">
              {t('footer.company')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-175">
              <li data-id="element-176">
                <a href={getPath('#about')} className="hover:underline" data-id="element-177">
                  {t('footer.aboutLink')}
                </a>
              </li>
              <li data-id="element-178">
                <a href={getPath('referral')} className="hover:underline" data-id="element-179">
                  {t('nav.referral')}
                </a>
              </li>
              <li data-id="element-180">
                <a href={getPath('#faq')} className="hover:underline" data-id="element-181">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-182">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-183">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-184">
              <li data-id="element-185">
                <a href={getPath('privacy')} className="hover:underline" data-id="element-186">
                  {t('nav.privacy')}
                </a>
              </li>
              <li data-id="element-187">
                <a href={getPath('terms')} className="hover:underline" data-id="element-188">
                  {t('nav.terms')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-189">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-190">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-191">
              <li data-id="element-192">
                <a href={TELEGRAM_LINK} target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-193">
                  Telegram
                </a>
              </li>
              <li data-id="element-194">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-195">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-196">
                <a href={`mailto:${EMAIL}`} className="hover:underline" data-id="element-197">
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: 'var(--border)'
      }} data-id="element-198">
          <div className="flex items-center gap-2" data-id="element-199">
            <span className="text-lg sm:text-xl font-bold tracking-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-200">
              Jetly Agency
            </span>
          </div>
          <div className="text-xs sm:text-sm text-center" style={{
          color: 'var(--text-muted)'
        }} data-id="element-201">
            © {new Date().getFullYear()} Jetly.agency. {t('footer.rights')}
          </div>
        </div>
      </div>
    </footer>;
}